/**
 * Meta Commerce custom code snippets
 */
(function(){

    /**
     * Product description "Read More"
     */
    $('.product-read-more').on('click', function() {
        let pDesc = $('.product-description').get(0);
        if ($(pDesc).css('max-height') =='none'){
            $(pDesc).css('max-height','600px');
            $(this).text('Read More');
            $(this).attr('aria-expanded', 'false');
        } else {
            $(pDesc).css('max-height','none');
            $(this).text('Read Less');
            $(this).attr('aria-expanded', 'true');
        }
    });

    if ($('.product-description').height() < 600) {
        $('.product-read-more').toggle(false);
    }

    /**
     * Handle ?review= param: jumps to write a review
     */
    if (getQueryVariable('review')) {
        let i = 0;
        let jumpToReviews = setInterval(function() {  // Iterating

            let reviewsButton = $('#judgeme_product_reviews .jdgm-write-rev-link');
            if (reviewsButton.length) {
                let scrollTo =  $(reviewsButton).offset().top;
                if (scrollTo) {  // Not zero
                    scrollTo -= 250;  // Not clear to me why this is sometimes necessary
                    $('html,body').animate({scrollTop: scrollTo},'slow');
                    reviewsButton[0].click();
                    clearInterval(jumpToReviews);
                }
            }
            if (i++ > 50) { // After 5 seconds, something went wrong
                clearInterval(jumpToReviews);
            }
        },100);
    }

    /**
     * ?video param: Jump to and open targeted video
     */
    let target_video = getQueryVariable('video');
    if (target_video) {
        setTimeout(function() {
            // Jump focus down to videos widget
            let video_elem = $('#product-videos');
            $('html,body').animate({scrollTop: video_elem.offset().top},'slow');
            // ?video=1 will highlight only / first: To highlight a specific one pass by id or idx
            if (target_video > 1) {
                if (target_video < 25) {
                    // Allow accessing the Nth vide by ?video=2, ?video=3 etc
                    let multiple_videos = $(video_elem).find('div.product-video');
                    if (multiple_videos.length >= target_video) {
                        target_video = $(multiple_videos[target_video - 1]).data('video-id')
                    }
                }
                if (target_video && target_video > 25) {
                    $('a[data-thumbnail-id="' + target_video + '"').click();
                }
            }
        }, 400);
    }

    /**
     * This is for the ZMan holiday promo 2019.
     * MCE is mail chimp: when their success form would be displayed (on form success)
     * Hide theirs and show ours.
     */
    $('#mce-success-response').on('DOMSubtreeModified', function() {
        $('#mce-success-response').hide();
        $('#mc_embed_signup').hide();
        $('#mce-success-response-custom').show();
    });

    /**
     * This injects "Write a Review" button into customerHub orders
     * Note that it uses the also-homegrown ?review link
     */
    if ($('div#CustomerHubApp').length) {
        $('.chProductLink').each(function() {
            let reviewhref = $(this).attr('href') + '?review=1';
            let button = '<a href="' + reviewhref + '" class="chProductLink"><button class="chButton">Write a Review</button>';
            $(this).before(button);
        });
    }


    /**
     * Grid and Explosive PDPs: link that "jumps" to where you can find the products
     */
    $('.jump-to').on('click', function() {
        let target_container = false;
        if ($('.explosive-variants-container').length) {
            target_container = $('.explosive-variants-container')[0];
        }
        if ($('#grid-product-grid').length) {
            target_container = $('#grid-product-grid')[0];
        }
        if (target_container) {
            $('html,body').animate({scrollTop: $(target_container).offset().top},'slow');
        }
    });

    if ($('nav.jump-to').length) {
        let navelem = $('nav.jump-to')[0];
        if (navelem.getBoundingClientRect().top > 600) {
            $('html,body').animate({scrollTop: $(navelem).offset().top - 50},1200);
        }
    }

    /**
     * Standard PDP iStock "Notify Me" timing fix.
     *
     * iStock-notify.js fires istockNotifyShow 300ms after a radio/select change event,
     * then reads [name=id] to get the selected variant. But Empire resolves the variant
     * asynchronously, so [name=id] may not be updated within that window. Empire may
     * also fire change events during its own init, which causes iStock to hide the
     * wrapper before it can show it on initial page load.
     *
     * Fix 1 (variant switch): listen for Empire's variant-change event (fires after
     * [name=id] is known), seed [name=id] ourselves, then call istockNotifyShow directly.
     *
     * Fix 2 (initial load): poll until iStockProduct is loaded, then re-run
     * istockNotifyShow after Empire finishes initializing.
     *
     * Only runs on standard PDP — explosive and grid have their own iStock wiring.
     */
    (function() {
        if (document.querySelector('.explosive-variant') || document.querySelector('#grid-product-container')) return;
        var variantSelection = document.querySelector('[data-variant-selection]');
        if (!variantSelection) return;

        function runNotifyShow() {
            if (typeof iStockVarIdOld !== 'undefined') iStockVarIdOld = 0;
            var wrapper = jQuery('.iStock-wrapper').parents(iStockWraperClass + ':visible');
            if (wrapper.length) {
                istockNotifyShow(iStockProduct, wrapper);
            }
        }

        // Fix 1: variant switch — Empire has already updated [name=id] by this point
        variantSelection.addEventListener('variant-change', function(e) {
            if (typeof istockNotifyShow !== 'function') return;
            if (typeof iStockProduct === 'undefined' || jQuery.isEmptyObject(iStockProduct)) return;

            var variant = e.detail.variant;
            var variantsSelect = document.querySelector('select[data-variants]');
            if (variantsSelect && variant) {
                variantsSelect.value = variant.id;
            }
            runNotifyShow();
        });

        // Fix 2: initial page load — self-contained OOS check, no dependency on iStock state.
        // Fetches the product JSON directly so this works even when there are no option
        // selectors (single OOS variant) and iStock's own init chain never fires.
        setTimeout(function() {
            var iStockWrapper = document.querySelector('.iStock-wrapper');
            if (!iStockWrapper) return;
            var handle = iStockWrapper.getAttribute('handle');
            if (!handle) return;

            jQuery.getJSON('/products/' + handle + '.js', function(product) {
                var variantInput = document.querySelector('[name=id]');
                if (!variantInput) return;
                var selectedId = parseInt(variantInput.value);
                var variant = product.variants.find(function(v) { return v.id === selectedId; });
                if (variant && !variant.available) {
                    jQuery(iStockWrapper).show();
                }
            });
        }, 800);
    })();

    /*
     * Doubly currency switcher — meta.js aria-label patch REMOVED 2026-09-15 (midyear audit).
     * The patch labeled Doubly's native <select>, but that <select> is display:none (not in the
     * accessibility tree), so labeling it accomplished nothing (and the patch ran on
     * $(document).ready(), before Doubly injected the select, so it never matched anyway).
     * The REAL control is Doubly's custom ".doubly-nice-select" widget, built from
     * non-focusable <span>/<li> elements with no ARIA roles/names — a Doubly-side keyboard/SR
     * accessibility gap (WCAG 2.1.1 / 4.1.2) that theme JS cannot reliably fix. Logged as a
     * third-party limitation for Doubly support. Currency switching is a secondary feature:
     * screen-reader users can still browse and check out in the default currency.
     */

})();

 function refreshZoom() {
    $('.image-zoom').each(function() {
        $(this).parent().trigger('zoom.destroy');
        $(this).parent().zoom({
                url:$(this).attr('data-zoom'),
                on: 'click',
                touch: false,
                onZoomIn: function() {
                    $(this).toggleClass('move-cursor');
                },
                onZoomOut: function() {
                    $(this).toggleClass('move-cursor');
                }
            }
        );
    });
};

$(document).ready(function(){

    /**
     * WCAG 2.1.1 — Footer accordion keyboard operability
     * The footer accordion triggers are <h2> elements (not buttons), so Enter/Space
     * do not natively fire click events. This handler bridges that gap.
     */
    $(document).on('keydown', '[data-accordion-trigger]', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    if ($('.explosive-variant').length == 0) {
        refreshZoom();
    }
    // Set all videos except first one inactive. This is done on ready because other js fills only visible video blocks
    // (There may be a brief flash all videos)
    $('.product-video:not(:first-child)').addClass('inactive');

    $('.thumbnail a').click(function() {
        let selected_video = $(this).data('thumbnail-id');
        $('.product-video').addClass('inactive');
        $('.product-video[data-video-id=' + selected_video +']').removeClass('inactive');
        $('.thumbnail').removeClass('active');
        $(this).parent().addClass('active');
    });

    $('#product-video-link a').on('click', function(e) {
        e.preventDefault();
        let target_container = $('#product-videos-mobile')[0];
        if (target_container) {
            $('html,body').animate({scrollTop: $(target_container).offset().top},'slow');
        }
    });

});

$(".sliding-link").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

/**
 * Updates the header's cart widget to show users the quantity of items in their cart.
 * @param {*} qty int
 */
function addToCartHeader(qty) {
    let currentQty = parseInt($('.site-header-cart--count').data('header-cart-count')) || 0;
    let newQty = currentQty + parseInt(qty)
    $('.site-header-cart--count')
        .data('header-cart-count', newQty)
        .attr('data-header-cart-count', newQty);
    if (newQty > 0) {
        $('.site-header-cart--count').addClass('visible');
    }
};

jQuery(document).ready(function($) {

    /* fix iOS touchmove issue */
    ;
    (function() {
        let touchingCarousel = false
        let startXCoordinate

        document.body.addEventListener('touchstart', e => {
            if (e.target.closest('.flickity-slider')) {
                touchingCarousel = true
            } else {
                touchingCarousel = false
                return
            }
            startXCoordinate = e.touches[0].pageX
        })

        document.body.addEventListener('touchmove', e => {
            if (
                !touchingCarousel ||
                !e.cancelable ||
                Math.abs(e.touches[0].pageX - startXCoordinate) < 8
            ) return
            e.preventDefault()
            e.stopPropagation()
        }, {
            passive: false
        })
    }())

    /* prevent resize in flickity if still animating
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
        if (!this.isAnimating) {
            resize.call(this);
        }
    };
    */
});